const EM_DASH = "\u2014";
const MAXIMUM_VISIBLE_DOCUMENT_PEEK_LINES = 6;

export type DocumentPeekTextRow = {
  label: string;
  value: string;
};

function peekField(value: string | null | undefined): string {
  const trimmed = value?.trim();
  return trimmed != null && trimmed !== "" ? trimmed : EM_DASH;
}

/** Header fields plus a capped SKU list for vendor invoice and receipt peek-through. */
export function buildDocumentPeekRows(input: {
  header: ReadonlyArray<{ label: string; value: string | null | undefined }>;
  lines: ReadonlyArray<{ sku: string; detail: string }>;
}): DocumentPeekTextRow[] {
  const rows: DocumentPeekTextRow[] = input.header.map((row) => ({
    label: row.label,
    value: peekField(row.value),
  }));
  const visible = input.lines.slice(0, MAXIMUM_VISIBLE_DOCUMENT_PEEK_LINES);
  for (const line of visible) {
    const sku = line.sku.trim();
    rows.push({
      label: sku !== "" ? sku : "Line",
      value: peekField(line.detail),
    });
  }
  const hidden = input.lines.length - visible.length;
  if (hidden > 0) {
    rows.push({
      label: "More",
      value: `${String(hidden)} more line${hidden === 1 ? "" : "s"}`,
    });
  }
  return rows;
}
